/* eslint-disable jsx-a11y/img-redundant-alt */
import { Gifts, Members, Orders, Promotions, Users } from './cs-connect'
import React, { useEffect, useMemo, useState } from 'react'
import MaterialTable from 'material-table';
import { useHistory, useParams } from 'react-router-dom';
import { Alert } from './utils/Alert.web';
import Progress from './utils/Progress.web';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import SearchBar from './components/SearchBar'
import Button from './components/Button'
import { View, Image, Text } from 'react-native';
import {
  WhereType} from 'firestar'
import { imageForProduct, useDebounce } from './utils';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { StylesProvider, createGenerateClassName } from '@material-ui/styles';
import EnterAddress from './EnterAddress'
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined'
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank'
import ButtonBase from '@material-ui/core/ButtonBase'
import Grid from '@material-ui/core/Grid'
import {
	getFirestore,
	collection,
	getCountFromServer
 } from 'firebase/firestore'
import { useCasinoContext } from './containers/CasinoContextProvider';
import CheckPermission from './utils/CheckPermission';
import CheckBox from './components/CheckBox';
import * as XLSX from 'xlsx'
import { saveAs } from "file-saver";

const generateClassName = createGenerateClassName({
	productionPrefix: 'mt',
	seed: 'mt'
}); //To prevent material table from changing appbar style


const INITIAL_PAGESIZE = 15
const PAGESIZE = 10


export default function BulkOrder() {

  const params = useParams() as { promotionId: string }
  const  { casino } = useCasinoContext()
  const casinoId = casino.id
  const { promotionId } = params ?? {}
  const [members, setMembers] = useState<Members.Member[]>([])
  const [gifts, setGifts] = useState<Gifts.ShopifyProduct[]>([])
	const [showLoader, setShowLoader] = useState<{
		title?: string,
		description?: string
	} | null>({
		title: 'Loading Members...'
	})
  const [activeStep, setActiveStep] = useState(0)
  const history = useHistory()
  const [selectedMemberIds, setSelectedMemberIds] = useState<{[key: string] : Members.Member}>({})
  const [selectedGiftId, setSelectedGiftId] = useState<string | null>()
  const [validationResult, setValidationResult] = useState<{
    rejected: string[],
    success: string[],
    failed: string[]
  }>()
  const [lastDoc, setLastDoc] = useState<any>()
  const [searchText, setSearchText] = useState('')
  const [showAlert, setShowAlert] = useState<{
    title: string,
    description: string,
	backgroundColor?: string
  } | null>()
  const [showShippingAddress, setShowShippingAddress] = useState(false)
  const [promotion, setPromotion] = useState<Promotions.Promotion>()
  const [searching, setSearching] = useState(false)
  const debouncedSearchTerm = useDebounce(searchText, 500);
  const [selectAll, setSelectAll] = useState(false)
  const [totalCount, setTotalCount] = useState<number>()
  const selectedGift = useMemo(() => {
    return gifts.find(({ id }) => Number(id) === Number(selectedGiftId))
  }, [selectedGiftId, gifts])

  const [automaticGiftSelection, setAutomaticGiftSelection] = useState<{[key: string]: Gifts.ShopifyProduct} | null>()

  let singleMember : Members.Member | undefined
  if(Object.keys(selectedMemberIds).length === 1){
    singleMember = members.find((m) => m.id === Object.keys(selectedMemberIds)[0])
  }

	useEffect(() => {
		if (casinoId && promotionId) {
			fetchPromotion(casinoId, promotionId)
		}
	}, [casinoId, promotionId])

	useEffect(() => {
		if (promotion != null) {
			fetchGifts()
		}
	}, [promotion])

	useEffect(() => {
		if (gifts.length > 0) {
			setShowLoader({ title: 'Fetching Members...' })
			fetchMembers('', false).then(() => {
				setShowLoader(null)
			})
		}
	}, [gifts])
	
	useEffect(() => {
		if (debouncedSearchTerm) {
			fetchMembers(debouncedSearchTerm, false)
		}
	}, [debouncedSearchTerm,]);

	async function fetchMembers(searchText: string, paginating: boolean) {

		setSearching(true)

		try {
			if (casinoId == null) throw new Error("Casino id not found");

			let where = [] as WhereType[]
			if ((searchText ?? '').length > 0) {
				const searchTags = (searchText ?? '').split(' ').map((text: string) => text.toLowerCase().trim()).filter((text: string) => text.length > 0)
				where = where.concat(searchTags.map((searchTag) => {
					return {
						fieldPath: `matches.${searchTag}`,
						value: true,
						opStr: '=='
					}
				}))
			}

			const membersResponse = await Members.getMembersForPromotion(casinoId, promotionId, {
				limit: paginating ? PAGESIZE : INITIAL_PAGESIZE,
				where: where,
				lastDoc: paginating ? lastDoc : undefined
			})

			console.log('Members', membersResponse.data.length)

			if (paginating) {
				setMembers([...members, ...membersResponse.data])
			} else {
				setMembers(membersResponse.data)
			}
			setLastDoc(membersResponse.lastDoc)

		} catch (error) {
			console.log('Error Fetching Members:', error)
			Alert.alert('Error Fetching Members', String(error))
		}
		setSearching(false)
	}

	async function fetchPromotion(casinoId: string, promotionId: string) {
		setShowLoader({ title: 'Fetching Promotion...' })
		try {
			const promotionResponse = await Promotions.getPromotion(casinoId, promotionId)
			if (promotionResponse == null) {
				throw new Error("Unable to find promotion");
			}
			setPromotion(promotionResponse)

			const coll = collection(getFirestore(), `casinos/${casinoId}/promotions/${promotionId}/members`);
			const snapshot = await getCountFromServer(coll);
			setTotalCount(snapshot.data().count)
		} catch (error) {
			console.log('Error Fetching Promotion', error)
			setShowLoader(null)
		}
	}

	async function fetchGifts() {
		setShowLoader({ title: 'Fetching Gifts...' })
		try {
			//   console.log('Fetching Gifts for Promotion', promotion?.productIds ?? [])
			const selectedResponse = await Gifts.getGiftsWithProductIds(promotion?.productIds ?? [], false)
			//   console.log('Recevied Gifts for Promotion:', selectedResponse)
			setGifts(selectedResponse)
		} catch (error) {
			console.log('Error Fetching Gifts:', error)
			Alert.alert('Error Fetching Gifts', String(error))
			setShowLoader(null)

		}
	}

	if (showLoader != null) { return <Progress title={showLoader.title} description={showLoader.description}/> }

  return (
	  <Grid container md={12}>
		  <div style={{
			width: '100%'
		  }}>
			  <Dialog fullWidth onClose={() => setShowAlert(null)} open={showAlert != null}>
				  <DialogTitle>{showAlert?.title}</DialogTitle>
				  <DialogContent>
					  <div style={{
						  padding: '2px 1em',
						  background: showAlert?.backgroundColor,
						  borderRadius: 5,
					  }}>{showAlert?.description}</div>
				  </DialogContent>
				  <div style={{
					  display: 'flex',
					  justifyContent: 'space-between',
					  padding: '1em'
				  }}>
					  <div />
					  <Button onPress={() => {
						  setShowAlert(null)
						  history.replace('/promotions/' + promotionId)
					  }} title='Okay' containerStyle={{
						  width: 100,
					  }} />
				  </div>
			  </Dialog>
			  <Dialog fullWidth onClose={() => setShowShippingAddress(false)} open={showShippingAddress}>
				  <DialogTitle>{'Enter Shipping Address'}</DialogTitle>
				  <DialogContent>
					  <EnterAddress
						  address={singleMember?.shippingAddress}
						  onPressUpdate={onAddShippingAddress}
						  onPressCancel={() => setShowShippingAddress(false)} />
				  </DialogContent>
			  </Dialog>
			  <Stepper activeStep={activeStep} orientation='vertical'>
				  <Step key={'select-members'} expanded={false}>
					  <StepLabel>
						  <b>Select Members</b>
						  {activeStep !== 0 && (
							  <div style={{ marginTop: '0.2em' }}>
								  {singleMember != null ? (
									  <div>
										  <div>{singleMember?.cardNumber}</div>
										  {singleMember.shippingAddress ? (
											  <div>
												  <div>{`${singleMember.shippingAddress?.firstName} ${singleMember.shippingAddress?.lastName}`}</div>
												  <div>
													  <div>{singleMember.shippingAddress?.street}</div>
													  <div><span>{singleMember.shippingAddress?.city}</span>&nbsp;<span>{singleMember.shippingAddress?.stateCode}</span></div>
													  <div>{singleMember.shippingAddress?.zipCode}</div>
												  </div>
											  </div>
										  ) : (
											  <div>
												  <div>{singleMember?.name}</div>
												  <div>
													  <div>{singleMember.address?.street}</div>
													  <div><span>{singleMember.address?.city}</span>&nbsp;<span>{singleMember.address?.stateCode}</span></div>
													  <div>{singleMember.address?.zipCode}</div>
												  </div>
											  </div>
										  )}
										  {Object.keys(selectedMemberIds).length === 1 && (promotion?.allowShippingAddress ?? false) && <div>
											  <div style={{ marginTop: '0.5em' }}>
												  <div>
													  <button onClick={() => {
														  setShowShippingAddress(true)
													  }}>{singleMember?.shippingAddress ? 'Update Shipping Address' : 'Change Address'}</button>
													  {singleMember?.shippingAddress != null && (
														  <button
															  style={{ marginLeft: '1em' }}
															  onClick={() => {
																  onAddShippingAddress(null)
															  }}>{'Clear'}</button>
													  )}
												  </div>
											  </div>
										  </div>}

									  </div>
								  ) : (
									  <div>
										  {Object.keys(selectedMemberIds).length > 0 && <p>Selected {Object.keys(selectedMemberIds).length} Members</p>}
									  </div>
								  )}
							  </div>
						  )}
					  </StepLabel>
					  {activeStep === 0 && <div style={{
						  padding: '2em'
					  }}>
						  <View style={{
							  flexDirection: 'row',
							  justifyContent: 'space-between'
						  }}>
							  <View />
							  <SearchBar
								  containerStyle={{
									  backgroundColor: 'white',
									  borderTopWidth: 0,
									  borderBottomWidth: 0,
									  padding: 0,
									  width: 400,
									  alignSelf: 'flex-end',
									  marginLeft: 10
								  }}
								  inputContainerStyle={{
									  backgroundColor: '#dddddd',
									  borderRadius: 20
								  }}
								  inputStyle={{
									  color: 'black'
								  }}
								  onClear={() => {
									  setSearchText('')
								  }}
								  placeholder='Search'
								  onChangeText={(text) => setSearchText(text)}
								  value={searchText} />
						  </View>
						  <br />
						  <StylesProvider generateClassName={generateClassName}>
							  <MaterialTable
								  title={'Select Members'}
								  style={{
									  opacity: selectAll ? 0.5 : 1,
									  pointerEvents: selectAll ? 'none' : undefined
								  }}
								  options={{
									  selection: false,
									  pageSize: Math.min(members.length, 10),
									  pageSizeOptions: [],
									  search: false
								  }}
								  isLoading={searching}
								  onChangePage={onChangePage}
								  columns={[
									  {
										  render: (member) => (
											  <input type='checkbox' checked={selectedMemberIds[member.id] != null} onChange={(event) => {
												  const __selectedMemberIds = { ...selectedMemberIds }
												  if (event.target.checked) {
													  __selectedMemberIds[member.id] = member
												  } else {
													  delete __selectedMemberIds[member.id]
												  }
												  setSelectedMemberIds(__selectedMemberIds)
											  }} />
										  )
									  },
									  {
										  field: 'id',
										  title: 'ID',
										  render: (member) => (
											  <>
												  <div>{member.id}</div>
												  <CheckPermission minimumRole="admin">
													  {member.orderInfo && <a target='_blank' href={`https://admin.infigifts.com/orders/${member.orderInfo.id}`} style={{
														  display: 'flex',
														  alignItems: 'center',
														  justifyContent: 'flex-start',
														  fontSize: 12
													  }} rel="noreferrer">
														  <label>{member.orderInfo?.name}</label>
													  </a>}
												  </CheckPermission>
											  </>
										  )
									  },
									  {
										  field: 'firstName',
										  title: 'First Name'
									  },
									  {
										  field: 'lastName',
										  title: 'Last Name',
									  },
									  {
										  title: 'Card Number',
										  field: 'cardNumber'
									  },
									  {
										  title: 'Enabled',
										  field: 'enabled'
									  },
									  {
										  title: 'Tier',
										  field: 'tier'
									  },
									  {
										  title: 'Phone Number',
										  field: 'phoneNumber'
									  },
									  {
										  title: 'Email',
										  field: 'email'
									  },
								  ]}
								  data={members} />
						  </StylesProvider>
						  <div style={{
							  textAlign: 'right',
						  }}>
							  <div style={{
								  fontSize: 14,
								  marginTop: 3,
								  color: '#11111190',
								  margin: '0.5em 0em'
							  }}>Total Members: {totalCount}</div>
							  <CheckPermission minimumRole="admin">
								  <>
									  <div>
										  <button onClick={() => onGetAllUnclaimed()}>Filter all unclaimed members</button>
									  </div>
								  </>
							  </CheckPermission>
						  </div>
						  <CheckPermission minimumRole="admin">
							  <>
								  <div>
									  <input id='select-all' type='checkbox' checked={selectAll} onClick={onToggleSelectAll}></input>
									  <label htmlFor='select-all'>&nbsp;Select all {totalCount} members from this promotion</label>
								  </div>
							  </>
						  </CheckPermission>
						  <br />
						  <View style={{
							  flexDirection: 'row'
						  }}>
							  <Button
								  onPress={() => {
									  setActiveStep(activeStep + 1)
								  }}
								  disabled={selectAll === false && Object.keys(selectedMemberIds).length === 0}
								  containerStyle={{
									  width: 200
								  }}
								  title='Continue' />
						  </View>
						  {Object.keys(selectedMemberIds).length > 0 && <p>Selected {Object.keys(selectedMemberIds).length} Members</p>}
					  </div>}
				  </Step>
				  <Step key='select-gift' expanded={false} style={{
					  width: '100%'
				  }}>
					  <StepLabel><b>Select Gift</b></StepLabel>
					  {activeStep === 1 ? (
						  <div style={{
							marginLeft: '1em'
						  }}>
							  <br />
							  <div>
								  <CheckBox title='Automatic Gift Selection' checked={automaticGiftSelection} onPress={() => {
									  if (automaticGiftSelection) {
										setAutomaticGiftSelection(null)
									  } else {
										  setAutomaticGiftSelection({})
									  }
								  }} />
								  <br/>
								  {automaticGiftSelection && (
									  <div style={{
										  padding: '1em',
										  border: '1px solid #dddddd',
										  display: 'flex',
										  flexDirection: 'column',
										  justifyContent: 'center'
									  }}>
										  <div style={{
											  width: '300px'
										  }}>
											  <button onClick={onPressDownloadTemplate}>Download Template</button>
											  <br /><br />
											  <label style={{
												  fontSize: 12,
												  marginBottom: '0.3em'
											  }}>Upload gift file (.xlsx)</label>
											  <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
										  </div>
										  <br/>
										  <MaterialTable
											  title={'Gifts by Members'}
											  options={{
												  selection: false,
												  pageSize: Math.min(members.length, 10),
												  pageSizeOptions: [],
												  search: false
											  }}
											  isLoading={searching}
											  onChangePage={onChangePage}
											  columns={[
												  {
													  field: 'firstName',
													  title: 'First Name'
												  },
												  {
													  field: 'lastName',
													  title: 'Last Name',
												  },
												  {
													  title: 'Card Number',
													  field: 'cardNumber'
												  },
												  {
													  title: 'Gift',
													  render: ({ cardNumber }) => {

														  const product = automaticGiftSelection[cardNumber ?? '']
														  return (
															  <div>
																  {product && (
																	  <div>{product.title}</div>
																  )}
															  </div>
														  )
													  }
												  }
											  ]}
											  data={members} />
									  </div>
								  )}
							  </div>
							  {!automaticGiftSelection && <>
								  {selectedGift == null ? (<div>
									  <div style={{
										  display: 'flex',
										  flexDirection: 'row',
										  flexWrap: 'wrap',
										  justifyContent: 'flex-start',
										  border: '1px solid #dddddd',
										  borderRadius: 5
									  }}>
										  {gifts.map((gift) => {
											  const thumbnail = imageForProduct(gift)
											  const checked = selectedGiftId === gift.id
											  return (
												  <View style={{
													  width: '15em',
													  justifyContent: 'space-between',
													  padding: '1em'
												  }}>
													  <View style={{
														  display: 'flex',
														  flexDirection: 'column',
														  borderWidth: checked ? 2 : 0.1,
														  borderColor: checked ? '#224ed4' : '#dddddd',
														  padding: '1em',
														  borderRadius: 5,
														  backgroundColor: '#dddddd20',
														  height: '100%',
														  justifyContent: 'space-between'
													  }}>
														  <ButtonBase onClick={() => {
															  setSelectedGiftId(gift.id)
														  }} style={{
															  alignSelf: 'flex-end',
															  marginBottom: '0.5em',
															  position: 'absolute',
															  top: 12,
															  right: 12,
															  zIndex: 100
														  }}>
															  {checked ? (
																  <CheckBoxOutlined />
															  ) : (
																  <CheckBoxOutlineBlank />
															  )}
														  </ButtonBase>
														  <View style={{
															  zIndex: 99
														  }}>
															  <Image style={{
																  width: '100%',
																  height: 150,
																  resizeMode: 'contain',
																  borderWidth: 1,
																  marginBottom: '0.5em',
																  marginTop: '1.5em'
															  }} source={{
																  uri: thumbnail
															  }} />
															  <b>{gift.title}</b>
															  <Text numberOfLines={0} style={{
																  marginTop: '0.1em',
																  fontSize: 12,
															  }}>{gift.body_html}</Text>
														  </View>
														  <Text style={{
															  textAlign: 'left',
															  width: '100%',
															  marginTop: '0.5em',
															  fontSize: 12
														  }}>Quantity available: <b>{gift.variants[0].inventory_quantity}</b></Text>
													  </View>
												  </View>
											  )
										  })}
									  </div>
								  </div>) : (<div>
									  <div>
											  {(() => {
												  const thumbnail = imageForProduct(selectedGift)
												  return (
													  <View pointerEvents={automaticGiftSelection ? 'none' : undefined} style={{
														  width: '15em',
														  justifyContent: 'space-between',
														  padding: '1em',
														  opacity: automaticGiftSelection ? 0.2 : 1,
														  backgroundColor: '#dddddd20',
														  borderColor: '#224ed4',
													  }}>
														  <View style={{
															  display: 'flex',
															  flexDirection: 'column',
															  borderWidth: 2,
															  padding: '1em',
															  borderRadius: 5,
															  height: '100%',
															  justifyContent: 'space-between'
														  }}>
															  <View style={{
																  zIndex: 99
															  }}>
																  <Image style={{
																	  width: '100%',
																	  height: 150,
																	  resizeMode: 'contain',
																	  borderWidth: 1,
																	  marginBottom: '0.5em',
																	  marginTop: '1.5em'
																  }} source={{
																	  uri: thumbnail
																  }} />
																  <b>{selectedGift.title}</b>
																  <Text numberOfLines={0} style={{
																	  marginTop: '0.1em',
																	  fontSize: 12,
																  }}>{selectedGift.body_html}</Text>
															  </View>
															  <Text style={{
																  textAlign: 'left',
																  width: '100%',
																  marginTop: '0.5em',
																  fontSize: 12
															  }}>Quantity available: <b>{selectedGift.variants[0].inventory_quantity}</b></Text>
														  </View>
													  </View>
												  )
											  })()}
									  </div>
								  </div>)}
							  </>}
							  <View style={{
								  flexDirection: 'row',
								  marginVertical: '1em'
							  }}>
								  <Button
									  onPress={() => setActiveStep(activeStep + 1)}
									  disabled={(automaticGiftSelection != null) ? Object.keys(automaticGiftSelection).length !== members.length  : selectedGiftId == null}
									  style={{
										  width: 100
									  }}
									  title='Continue' />
								  <Button
									  onPress={() => setActiveStep(activeStep - 1)}
									  style={{
										  width: 100,
										  marginLeft: '1em'
									  }}
									  type='text'
									  title='Back' />
								  {(selectedGiftId || automaticGiftSelection) && (
									  <Button
										  onPress={() => {
											setSelectedGiftId(null)
											setAutomaticGiftSelection(null)
										  }}
										  style={{
											  width: 100,
											  textAlign: 'center',
											  border: '1px solid gray',
											  marginLeft: '1em'
										  }}
										  type='text'
										  title='Clear' />
								  )}
							  </View>
						  </div>
					  ) : (
						  <div style={{
							  marginLeft: '2em'
						  }}>
							  {selectedGift && <div>
								  <div>
									  {(() => {
										  const thumbnail = imageForProduct(selectedGift)
										  return (
											  <View pointerEvents={automaticGiftSelection ? 'none' : undefined} style={{
												  width: '15em',
												  justifyContent: 'space-between',
												  padding: '1em',
												  opacity: automaticGiftSelection ? 0.2 : 1,
												  backgroundColor: '#dddddd20',
												  borderColor: '#224ed4',
											  }}>
												  <View style={{
													  display: 'flex',
													  flexDirection: 'column',
													  borderWidth: 2,
													  padding: '1em',
													  borderRadius: 5,
													  height: '100%',
													  justifyContent: 'space-between'
												  }}>
													  <View style={{
														  zIndex: 99
													  }}>
														  <Image style={{
															  width: '100%',
															  height: 150,
															  resizeMode: 'contain',
															  borderWidth: 1,
															  marginBottom: '0.5em',
															  marginTop: '1.5em'
														  }} source={{
															  uri: thumbnail
														  }} />
														  <b>{selectedGift.title}</b>
														  <Text numberOfLines={0} style={{
															  marginTop: '0.1em',
															  fontSize: 12,
														  }}>{selectedGift.body_html}</Text>
													  </View>
												  </View>
											  </View>
										  )
									  })()}
								  </div>
							  </div>}
						  </div>
					  )}
				  </Step>
				  <Step key='validate-orders' expanded={false}>
					  <StepLabel><b>Validate Orders</b></StepLabel>
					  {activeStep == 2 && <View style={{
						  paddingLeft: '2em'
					  }}>
						  {validationResult != null && (
							  <View>
								  {validationResult.success.length > 0 && <span style={{
									  marginBottom: '5px',
									  borderRadius: 5,
									  padding: '0.3em 1em',
									  background: "green",
									  color: 'white'
								  }}>{validationResult.success.length} order(s) passed validation check. Click on "Place Order" to complete your order.</span>}
								  {validationResult.failed.length > 0 && <span style={{
									  marginBottom: '5px',
									  borderRadius: 5,
									  background: "red",
									  padding: '0.3em 1em',
									  color: 'white'
								  }}>{validationResult.failed.length} order(s) failed validation. This could be due to ineligibility, expiration etc. Reason mentioned below.</span>}
								  {validationResult.rejected.length > 0 && <span style={{
									  marginBottom: '5px',
									  borderRadius: 5,
									  background: "brown",
									  padding: '0.3em 1em',
									  color: 'white'
								  }}>{validationResult.rejected.length} order(s) were rejected. This could be due to a network connection issue or a fault in the system.</span>}
								  <br />
								  {validationResult.failed.length > 0 && <div>
									  <label><b>Failed List:</b></label><br />
									  {validationResult.failed.map((s) => <div>{s}</div>)}
									  <br />
								  </div>}
								  {validationResult.rejected.length > 0 && <div>
									  <label><b>Rejected List:</b></label><br />
									  {validationResult.rejected.map((s) => <div>{s}</div>)}
									  <br />
								  </div>}
							  </View>
						  )}
						  <br />
						  <View style={{
							  flexDirection: 'row',
							  alignItems: 'center'
						  }}>
							  <View style={{
								  flexDirection: 'row'
							  }}>
								  {validationResult == null ? (
									  <Button
										  onPress={() => onPressPlaceOrder(true)}
										  containerStyle={{
											  width: 300,
											  marginRight: '1em'
										  }}
										  title='Validate' />
								  ) : (
									  <Button
										  onPress={() => {
											  onPressPlaceOrder()
										  }}
										  containerStyle={{
											  width: 300,
											  marginRight: '1em'
										  }}
										  disabled={validationResult.success.length == 0}
										  title='Place Order' />
								  )}
								  <Button
									  type='text'
									  onPress={() => {
										  setActiveStep(activeStep - 1)
										  setValidationResult(undefined)
									  }}
									  containerStyle={{
										  width: 200
									  }}
									  title='Back' />
							  </View>
						  </View>
					  </View>}
				  </Step>
			  </Stepper>
		  </div>
	  </Grid>
  )

  function onChangePage(page: number, pageSize: number) {
    if ((members.length / pageSize / page <= (INITIAL_PAGESIZE / PAGESIZE))) {
       if (lastDoc != null) fetchMembers(searchText, true)
    }
  }

  async function onAddShippingAddress(address: Members.ShippingAddress | null){
    const ___members = [...members]
    if (Object.keys(selectedMemberIds).length === 1) {
      const memberId = Object.keys(selectedMemberIds)[0]
      const index = members.findIndex((m) => m.id === memberId)
      if(index >= 0 && casinoId != null){
        const response = await Members.updateMember(casinoId, promotionId, memberId, {
          shippingAddress: address
        })
        const __member = {
          ...___members[index],
          ...response
        } as Members.Member
        __member.shippingAddress = address
        ___members[index] = __member
        setMembers(___members)
      }
    }
    setShowShippingAddress(false)
	}

	function handleFileUpload(event: any) {
		const file = event.target.files[0];
		if (!file) return;

		const reader = new FileReader();
		reader.onload = (e) => {

			if (e.target) {
				
				const binaryStr = e.target.result;
				const workbook = XLSX.read(binaryStr, { type: "binary" });
				const sheetName = workbook.SheetNames[0]; // Read the first sheet
				const sheet = workbook.Sheets[sheetName];
				const parsedData = XLSX.utils.sheet_to_json(sheet) as {
					name: string
					cardNumber: string
					productId: string,
					productTitle: string
				}[]

				const __automaticGiftSelection = { ...automaticGiftSelection }
				parsedData.forEach(({ cardNumber, productId, productTitle }) => {
					__automaticGiftSelection[cardNumber] = {
						id: productId,
						title: productTitle
					} as Gifts.ShopifyProduct
				})
				setAutomaticGiftSelection(__automaticGiftSelection)
			}
		};
		reader.readAsBinaryString(file);
	};
	

	function onPressDownloadTemplate() {

		const fileName = `automatic_gift_selection`

		const __members = members.filter(({ id }) => selectedMemberIds[id] != null).map(({ name, cardNumber }) => { return { name, cardNumber, productId: '', productTitle: '' } })

		const __gifts = gifts.map(({ id, title }) => { return { id: String(id), title } })

		// Convert JSON to worksheet
		const ms = XLSX.utils.json_to_sheet(__members);
		const gs = XLSX.utils.json_to_sheet(__gifts);

		// Create a new workbook and append the worksheet
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ms, "Members");
		XLSX.utils.book_append_sheet(wb, gs, "Gifts");
		// Generate Excel file buffer
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

		// Create a Blob and trigger download
		const file = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
		saveAs(file, fileName);

	}

	async function onPressPlaceOrder(validateOnly?: true) {

		setShowLoader({})
		try {

			const success = [] as string[]
			const failed = [] as string[]
			const rejected = [] as string[]

			await Object.keys(selectedMemberIds).reduce((previous, memberId, index) => {
				return previous.then(() => {
					return new Promise<void>(async (resolve) => {

						setShowLoader({
							title: `${validateOnly === true ? 'Validating' : 'Processing'} ${index}/${Object.keys(selectedMemberIds).length}`,
							description: `Success: ${success.length}\n\nFailed: ${failed.length}\n\nRejected: ${rejected.length}`
						})

						const member = selectedMemberIds[memberId]
						try {
							if (member == null) {
								throw new Error("Member Not Found");
							}
							if (member.cardNumber == null) {
								throw new Error("Card Number Not Found");
							}
							if (casinoId == null) {
								throw new Error("Cassino Id Not Found");
							}

							let giftId = selectedGiftId
							if (automaticGiftSelection) {
								giftId = automaticGiftSelection[member.cardNumber].id
								if (giftId == null) throw new Error("Gift not selected");
							} else {
								if (giftId == null) {
									throw new Error("Gift Id Id Not Found");
								}
							}

							let shouldCreateFallbackEmail = false
							if ((member.email ?? '').length === 0 && (member.phoneNumber ?? '').length === 0) {
								shouldCreateFallbackEmail = true
							}

							const memberName = ((member.firstName ?? '') + ' ' + (member.lastName ?? '')).trim()

							console.log('Creating user account: ', memberName, member.email)

							const userResponse = await Users.createUserAccount(member.phoneNumber, memberName, member.email, shouldCreateFallbackEmail, {
								cardNumber: member.cardNumber,
								casinoId
							})

							const userInfo = Users.getCurrentUserInfo()

							const orderResponse = await Orders.checkout(
								userResponse.uid,
								casinoId,
								promotionId,
								giftId,
								member.id,
								undefined,
								validateOnly,
								userInfo,
								'bulk',
								{}
							)

							console.log('Validation Response:', orderResponse)

							if (orderResponse.status === 'success') {
								success.push(`${member.cardNumber} - ${member.name} : Success`)
								console.log('✅ Validation Success', member?.id, member?.name, orderResponse)

							} else if (orderResponse.status === 'failed') {
								console.log('⛔️ Validation Failed', member?.id, member?.name, orderResponse)
								failed.push(`${member.cardNumber} - ${member.name} - ${member.email ?? '*'} - ${member.phoneNumber ?? '*'} : ${(orderResponse as any).message}`)
							}

							resolve()

						} catch (e) {

							const error = e as Error
							rejected.push(`${member?.cardNumber} - ${member?.name} - ${member.email ?? '*'} - ${member.phoneNumber ?? '*'} : ${error.message ?? String(error)}`)
							console.log('❌ Validation Rejected', error.message, member?.id, member?.name)

							resolve()
						}
					})
				})
			}, Promise.resolve())

			setValidationResult({
				failed: failed,
				rejected: rejected,
				success: success
			})

			console.log('Result', {
				failed: failed.length,
				rejected: rejected.length,
				success: success.length
			})

			if (!validateOnly) {
				setShowAlert({
					title: 'Order Successful',
					description: `${success.length} order(s) have been successfully placed.`,
					backgroundColor: '#34eba1'
				})
			}
		} catch (error) {
			console.log('Error Placing Orders', error)
			Alert.alert('Error Placing Orders', String(error))
		}
		setShowLoader(null)
	}


	async function onGetAllUnclaimed() {

		setShowLoader({
			title: 'Fetching all members...'
		})

		try {

			const membersResponse = await Members.getMembersForPromotion(casinoId, promotionId, {
				limit: 10000
			})
			setMembers(() => membersResponse.data.filter((m) => m.orderInfo?.name == null))
			setLastDoc(() => membersResponse.lastDoc)

		} catch (error) {
			alert('Error selecting all members' + String(error))
		}

		setShowLoader(null)
	}

	async function onToggleSelectAll() {

		setShowLoader({
			title: 'Fetching all members...'
		})

		try {

			const __selectAll = !selectAll
			if (__selectAll === true) {

				const __selected = {}
				if (totalCount !== members.length) {
					const membersResponse = await Members.getMembersForPromotion(casinoId, promotionId, {
						limit: 10000
					})

					membersResponse.data.forEach((member) => {
						__selected[member.id] = member
					})

					setMembers(() => membersResponse.data)
					setLastDoc(() => membersResponse.lastDoc)
				} else {

					members.forEach((member) => {
						__selected[member.id] = member
					})
					
				}

				setSelectedMemberIds(() => __selected)
			} else {
				setSelectedMemberIds({})
			}
			setSelectAll(__selectAll)
		} catch (error) {
			alert('Error selecting all members' + String(error))
		}

		setShowLoader(null)
	}

}
